import styled from 'styled-components';

const MessageIcon = styled.img`
  width: 42px;
  height: 42px;
  margin-left: 20px;
`;

export default MessageIcon;
